import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * Vive dentro del grupo `_contabilidad`, así que el guardián ya se aplicó y esta ruta no repite
 * ninguna verificación.
 *
 * EL ESCENARIO NOMBRA AL ADMINISTRADOR («Cuando el administrador consulta las anulaciones del
 * mes») y `_contabilidad` lo contiene, que es lo que la adjudicación 177 exige. El contador entra
 * también, y es deliberado: esta es una pantalla de LECTURA que sostiene el cierre de mes, que él
 * hace, y el filtro real de lo que cada quien ve no lo pone el guardián sino `rep.v_anulacion`,
 * que es `security_invoker`. El grupo abre la puerta; la seguridad por filas decide qué hay
 * adentro.
 *
 * NO VA EN UN GRUPO NUEVO CON `movimiento.anular`. Esa acción es del jefe de operarios, el
 * contador y el administrador, y ninguno de los cuatro grupos coincide con ese conjunto; pero es
 * la acción de ANULAR, y acá no se anula nada. `DialogoAnular`, que sí anula, sigue sin pantalla
 * anfitriona y queda reportado: elegir su grupo es elegir desde qué lista de movimientos se anula,
 * que es una decisión de diseño y no un cableado.
 */
export const rutaAnulaciones = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/anulaciones',
  component: lazyRouteComponent(() => import('./anulaciones-pantalla.js'), 'RutaAnulaciones'),
});
